import ContentCard from "../../../Components/ContentCard";
import PDFWatermark from "../../../Components/PDFWatermarks";
import { Helmet } from "react-helmet-async";

const Watermark = () => {
    return (
        <>
            <Helmet>
                <title>PDF Wasserzeichen hinzufügen – kostenlos online | FileForge</title>
                <meta name="description" content="Fügen Sie Text- oder Bild-Wasserzeichen zu Ihren PDF-Dateien hinzu – kostenlos, ohne Anmeldung, direkt im Browser." />
                <link rel="canonical" href="https://www.file-forge.org/pdf-wasserzeichen-hinzufuegen" />
            </Helmet>

            <ContentCard
                title="Wasserzeichen hinzufügen"
                description="Fügen Sie Wasserzeichen zu Ihren PDF-Dateien hinzu."
                baseClases="p-6 m-2 border flex flex-col gap-4 w-full"
            >
                <PDFWatermark />
            </ContentCard>
        </>
    )
}

export default Watermark